export function getDate() {
	var date = new Date() // 获取时间
	var year = date.getFullYear() // 获取年
	var month = date.getMonth() + 1 // 获取月
	month = (month > 9) ? month : ('0' + month);
	var strDate = date.getDate() // 获取日
	strDate = (strDate < 10) ? ('0' + strDate) : strDate;
	return year+'-'+month+'-'+strDate
}

export function getOtherDate(num) {
	var date = new Date() // 获取时间
	date.setDate((date.getDate()+num))
	var year = date.getFullYear() // 获取年
	var month = date.getMonth() + 1 // 获取月
	month = (month > 9) ? month : ('0' + month);
	var strDate = date.getDate() // 获取日
	strDate = (strDate < 10) ? ('0' + strDate) : strDate;
	return year+'-'+month+'-'+strDate
}

